module.exports = __webpack_public_path__ + "static/media/TriageAI.ced22de1.png";